import { render, staticRenderFns } from "./ChangeClassDialog.vue?vue&type=template&id=646f029e"
import script from "./ChangeClassDialog.vue?vue&type=script&lang=js"
export * from "./ChangeClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports